import { useState, useRef, useEffect } from "react";
import { FaFilePdf, FaFileAlt } from "react-icons/fa";

const AttachmentDownload = ({ fileUrl, fileName, isImage, isDoc }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuPos, setMenuPos] = useState({ x: 0, y: 0 });
  const containerRef = useRef(null);

  // Right-click context menu position
const onContextMenu = (e) => {
  e.preventDefault();
  
  const rect = containerRef.current.getBoundingClientRect();
  const menuWidth = 150;
  const menuHeight = 70; // adjust if needed
  const verticalOffset = 5;

  let x = e.clientX - rect.left;
  let y = e.clientY - rect.top;

  // Prevent overflow on right side
  if (x + menuWidth > rect.width) {
    x = rect.width - menuWidth;
  }

  // Prevent overflow on bottom side
  if (y + menuHeight > rect.height) {
    y = rect.height - menuHeight;
  }

  setMenuPos({ x, y: y + verticalOffset });
  setMenuOpen(true);
};


  // Left click toggle (for PDFs)
  const toggleMenuClick = () => {
    setMenuPos({ x: 0, y: "100%" });
    setMenuOpen(!menuOpen);
  };

  // Open file in new tab
const handleOpen = () => {
  if (isDoc) {
    const driveViewerUrl = `https://drive.google.com/viewerng/viewer?embedded=true&url=${encodeURIComponent(fileUrl)}`;
    window.open(driveViewerUrl, "_blank");
  } else {
    window.open(fileUrl, "_blank");
  }
  setMenuOpen(false);
};


  // Download via backend proxy
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = `${process.env.REACT_APP_CHAT_ATTACHMENT_DOWNLOAD}?url=${encodeURIComponent(fileUrl)}`;
    link.setAttribute("download", fileName || (isImage ? "image.jpg" : "file.pdf"));
    document.body.appendChild(link);
    link.click();
    link.remove();
    setMenuOpen(false);
  };

  // Close menu on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    if (menuOpen) {
      document.addEventListener("click", handleClickOutside);
    }
    return () => document.removeEventListener("click", handleClickOutside);
  }, [menuOpen]);

  return (
    <div ref={containerRef} style={{ display: "inline-block", position: "relative" }}>
      {isImage ? (
  <img
    src={fileUrl}
    alt={fileName}
    style={{ maxWidth: 200, cursor: "context-menu" }}
    onContextMenu={onContextMenu}
    title="Right click for options"
  />
) : (
  <span
    onClick={toggleMenuClick}
    onContextMenu={onContextMenu}
    style={{
      cursor: "pointer",
      color: "blue",
      textDecoration: "underline",
      fontWeight: "bold",
      userSelect: "none",
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
    }}
    title={fileName}
  >
    {isDoc ? <FaFileAlt color="green" size={16} /> : <FaFilePdf color="red" size={16} />}
    {fileName.length > 10 ? `${fileName.slice(0, 10)}...` : fileName}
    <span style={{ userSelect: "none" }}>⋮</span>
  </span>
)}


      {menuOpen && (
        <div
          style={{
            position: "absolute",
            top: typeof menuPos.y === "number" ? menuPos.y : undefined,
            bottom: typeof menuPos.y === "string" ? 0 : undefined,
            left: menuPos.x,
            background: "white",
            border: "1px solid #ccc",
            borderRadius: 4,
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            zIndex: 10000,
            minWidth: 150,
          }}
        >
          <button
            onClick={handleOpen}
            style={{
              display: "block",
              padding: "8px 12px",
              background: "none",
              border: "none",
              width: "100%",
              textAlign: "left",
              cursor: "pointer",
            }}
          >
            Open in Browser
          </button>
          <button
            onClick={handleDownload}
            style={{
              display: "block",
              padding: "8px 12px",
              background: "none",
              border: "none",
              width: "100%",
              textAlign: "left",
              cursor: "pointer",
            }}
          >
            Download
          </button>
        </div>
      )}
    </div>
  );
};

export default AttachmentDownload;
